var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnlineFiling = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.75 74.5L78.25 87L69.5 78.25L73.25 74.5L78.25 79.5L87 70.75L90.75 74.5ZM47 37C44.225 37 42 39.25 42 42V82C42 84.775 44.225 87 47 87H66.525C65.625 85.45 65 83.75 64.7 82H47V42H64.5V54.5H77V64.7C77.825 64.575 78.675 64.5 79.5 64.5C80.35 64.5 81.175 64.575 82 64.7V52L67 37M52 62V67H72V62M52 72V77H64.5V72H52Z",
    fill: "#F26722"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnlineFiling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/online-filing.4282073a7a5d03122170ef8ab0ec31d8.svg";